import { createAsyncThunk } from "@reduxjs/toolkit";
import { mapBuildingControlProjectsTypes } from "../Types/BuildingControl/BuildingControlProjectsType";
import { getAllBuildingControlProjects } from "../../Api/BuildingControlService/BuildingControlService";

// fetch all building control project list
export const fetchAllBuildingControlProjects = createAsyncThunk('fetchAllBuildingControlProjects', async (_, { rejectWithValue }) => {
    try {
        // api
        const response = await getAllBuildingControlProjects();
        if (response.status) {
            return mapBuildingControlProjectsTypes(response.body);
        } else {
            // If the API returns a failure status, return the error message
            return rejectWithValue(response.error);
        }
    } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch building control projects');
    }
});